export {
  getClosestMatch,
  getClosestMatches,
  MissingUpstreamDataError
} from './getClosestMatch'
